import TrainingHeader from './component.jsx'
export default TrainingHeader
